import { provideLazy } from '@/rules-management/injections.ts';
import { RULES_REPOSITORY } from '@/rules-management/RulesManagementKeys.ts';
import { initRule } from '@/rule';
import { RulesRepositoryRule } from '@/rules-management/secondary/RulesRepositoryRule.ts';
import { key, piqure } from 'piqure';
import { type AuthenticatedFetcher, buildFetcher } from '@/generic/authentication';
import { config } from '@/config';

export const PROVIDE_RULES_MANAGEMENT = Symbol('Provide rules management');

const FETCHER = key<AuthenticatedFetcher>('Rules management fetcher');

const local = piqure();

export const provideRulesManagement = () => {
  const { injectRulesRepository } = initRule();
  local.provideLazy(FETCHER, () => buildFetcher());

  provideLazy(
    RULES_REPOSITORY,
    () =>
      new RulesRepositoryRule(
        injectRulesRepository(),
        local.inject(FETCHER),
        config().pollingDuration,
      ),
  );
};
